import {CatalogServices} from 'services';
import {EfeCatalog, EfeCatalogValue} from 'commons/models';
import {useCatalogContext} from 'context/onboarding-catalog/OnboardingCatalog';
import {Constants} from 'commons/constants';

async function useCatalogSearch(catalogId: string): Promise<Array<EfeCatalogValue> | undefined> {
    const {catalogs, updateCatalogs} = useCatalogContext();
    const data: EfeCatalog | undefined = catalogs.find(
        (catalog: EfeCatalog) => catalog.name === catalogId
    );
    let catValues: Array<EfeCatalogValue> | undefined = [];
    if (data) {
        catValues = data.values;
    } else if (catalogId === Constants.CAT_SEPOMEX) {
        catValues = [];
    } else {
        try {
            const response = await CatalogServices.getValuesFrom(catalogId);
            if (response.data && response.data.values && response.data.values.length) {
                updateCatalogs(response.data);
                catValues = response.data.values;
            } else {
                catValues = undefined;
            }
        } catch (error) {
            catValues = undefined;
        }
    }
    return catValues;
}

export {useCatalogSearch};
